export default {"src":"/_next/static/media/mangos.77b43486.svg","height":200,"width":200,"blurWidth":0,"blurHeight":0};